import { render, staticRenderFns } from "./marcaForm.vue?vue&type=template&id=32097e5a&"
import script from "./marcaForm.vue?vue&type=script&lang=js&"
export * from "./marcaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports